import { Grid } from '@chakra-ui/react'
import { UserProfile, UserCardProps} from '../components/UserProfile'

const USERS: UserCardProps[] = [{
    name: 'Sohee Yoon',
    description: 'GIF Master',
    //link: string;
    imageUrl: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.shareicon.net%2Fdata%2F2016%2F09%2F15%2F829452_user_512x512.png&f=1&nofb=1&ipt=d75275b8bd0c81781326a5e58cf2547446ca1498f7fa62cfbb2213bcd7df9c12&ipo=images',
  },
  {
    name: 'Jessica',
    description: 'The Mechanic',
    imageUrl: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.wolfhooker.com%2Fwp-content%2Fuploads%2F2019%2F02%2F293-2931307_account-avatar-male-man-person-profile-icon-profile-icons.png.jpeg&f=1&nofb=1&ipt=32b90f6262b8e599acce4dc628e6684fcd1a4eadd0359d43f49f91d842d80887&ipo=images'

  }]

  export function Users() {
    return (
      <Grid templateRows='repeat(3, 1fr)' gap={6}>
        {USERS.map((p: UserCardProps, index) => {
          return <UserProfile key={index} imageUrl={p.imageUrl} name={p.name} description={p.description} />
        }
        )}
      </Grid>
    )
  }